import { History } from "lucide-react";

const when = (iso) => new Date(iso).toLocaleString("ro-RO", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export default function BFListHistory({ rows, names, lead }) {
  const list = (lead ? rows.filter((r) => r.lead === lead) : rows).slice(0, 15);
  return (
    <div className="bf-list-hist" data-testid="bf-list-history">
      <div className="st-section-title"><History size={12} /> {lead ? "Liste trimise acestui salon" : "Ultimele liste trimise"}</div>
      {!list.length && <p className="st-hint" data-testid="bf-list-history-empty">Nicio listă trimisă încă.</p>}
      <ul>
        {list.map((r) => (
          <li key={r.id} data-testid={`bf-list-history-${r.id}`}>
            <b>{r.salon || "Fără salon ales"}</b>
            <span>{r.brands.map((b) => names[b] || b).join(", ")}</span>
            <small>{when(r.created_at)}{r.agent_name ? ` · ${r.agent_name}` : ""}</small>
          </li>
        ))}
      </ul>
    </div>
  );
}
